import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectWorkspaceTheme } from 'containers/App/selectors';

function enhanceWithThemes(WrappedComponent, themes) {
  class EnhancedComponent extends Component {
    getTheme = (themeId) => {
      switch (themeId) {
        case 'dark':
          return themes.dark;
        case 'light':
          return themes.light;
        case 'extra-light':
          return themes['extra-light'] || themes.light;
        default:
          return themes[themeId];
      }
    };

    mergeThemes = (parentTheme = {}) => {
      const themeId = this.props.theme || parentTheme.themeId || 'light';

      const newTheme = this.getTheme(themeId);
      return { ...parentTheme, ...newTheme };
    };

    render() {
      const { theme, workspaceTheme, ...allOtherProps } = this.props;

      return (
        <ThemeProvider theme={this.mergeThemes} key={workspaceTheme}>
          <WrappedComponent {...allOtherProps} />
        </ThemeProvider>
      );
    }
  }

  const mapStateToProps = createStructuredSelector({
    workspaceTheme: makeSelectWorkspaceTheme(),
  });

  const withConnect = connect(mapStateToProps);

  EnhancedComponent.propTypes = {
    theme: PropTypes.string,
    workspaceTheme: PropTypes.string,
  };

  return compose(withConnect)(EnhancedComponent);
}

export default enhanceWithThemes;
